import { graphql, useStaticQuery } from '@amazeelabs/gatsby-plugin-operations';
import { PageFeedbackSettingsQuery } from '@custom/schema';

export const useSettingsPageFeedbackQuery = () =>
  useStaticQuery(graphql(PageFeedbackSettingsQuery));
